import { createContext, useContext, useState, useCallback, useMemo } from "react";
import { translations } from "@/data/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window !== "undefined") {
      return localStorage.getItem("glamp_lang") || "pt";
    }
    return "pt";
  });

  const setLang = useCallback((l) => {
    const languageCode = l.toLowerCase();
    setLangState(languageCode);
    localStorage.setItem("glamp_lang", languageCode);
  }, []);

  const t = useCallback((key) => {
    const keys = key.split(".");
    const getDeepValue = (obj, pathKeys) => {
      return pathKeys.reduce((prev, curr) => (prev && prev[curr] !== undefined ? prev[curr] : undefined), obj);
    };

    // Tenta Holandês. Se não houver, tenta Português. Se não houver, mostra a chave.
    let val = getDeepValue(translations[lang], keys);
    if (val === undefined) {
      val = getDeepValue(translations["pt"], keys);
    }
    return val !== undefined ? val : key;
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) throw new Error("useLanguage must be used within a LanguageProvider");
  return context;
}
